import { render, staticRenderFns } from "./Relay.vue?vue&type=template&id=445857fc&scoped=true"
import script from "./Relay.vue?vue&type=script&lang=js"
export * from "./Relay.vue?vue&type=script&lang=js"
import style0 from "./Relay.vue?vue&type=style&index=0&id=445857fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445857fc",
  null
  
)

export default component.exports